export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyBKZN2kFLXs1yk2lOOaqvDfSNV1exU8xj8",
    authDomain: "ubm-report-app.firebaseapp.com",
    databaseURL: "https://ubm-report-app.firebaseio.com",
    projectId: "ubm-report-app",
    storageBucket: "ubm-report-app.appspot.com",
    messagingSenderId: "899009219210",
    appId: "1:899009219210:web:7798d09e4bb068937c7b73",
    measurementId: "G-2VWC8L8CVD"}
};
